import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-side-bar-info',
  templateUrl: './side-bar-info.component.html',
  styleUrls: ['./side-bar-info.component.scss'],
})
export class SideBarInfoComponent implements OnInit {
  showAddParent = false;
  showAddChild = false;
  newChild = '';
  newParent = '';
  unsavedChanges = false;
  @Input('layoutMode') layoutMode;
  @Output() layoutModeChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() manageNewNodesUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Input('node') node;

  constructor(public generalService: GeneralService) {}

  ngOnInit(): void {}
  submit() {
    if (this.showAddChild) this.node.childs.unshift(this.newChild);
    if (this.showAddParent) this.node.Parent.unshift(this.newParent);

    this.newChild = '';
    this.newParent = '';
    this.showAddParent = false;
    this.showAddChild = false;
    this.unsavedChanges = true;
  }
  close() {
    this.unsavedChanges = false;
    this.manageNewNodesUpdate.emit(this.node);
  }
  changeLayoutMode(mode) {
    this.layoutMode = mode;
    this.layoutModeChange.emit(this.layoutMode);
  }
}
